
import { documentStore } from "@/store/store";
import { TreeNode } from "@/types/tree";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class AddSectionButton extends Vue {
  @Prop()
  elementId!: TreeNode["id"];

  addAnother() {
    documentStore.duplicateElement({elementId: this.elementId});
  }
}
